import { useQuery } from '@tanstack/react-query'

import { getUserAttributes } from 'api/user'
import { TUserAttribute } from 'shared'

const useAttributes = (keys: string[]) => {
  const { data: attributes = [], isLoading } = useQuery({
    queryKey: ['attributes'],
    queryFn: getUserAttributes,
    staleTime: 5 * 60 * 1000,
  })

  const attrs: Record<string, TUserAttribute | undefined> = {}

  for (const key of keys) {
    const attr = attributes.find(({ id }) => id === key)

    if (attr) {
      attrs[key] = attr
    }
  }

  if (!keys.length) {
    for (const attr of attributes) {
      attrs[attr.id] = attr
    }
  }

  return { attributes: attrs, isLoading }
}

export default useAttributes
